/**
 * @generated SignedSource<<f74dd131125ef81b53ae20f305f5cc80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkAdditionalInfo_charge$data = {
  readonly additionalInfo: ReadonlyArray<{
    readonly key: string | null | undefined;
    readonly value: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "PaymentLinkAdditionalInfo_charge";
};
export type PaymentLinkAdditionalInfo_charge$key = {
  readonly " $data"?: PaymentLinkAdditionalInfo_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkAdditionalInfo_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkAdditionalInfo_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Parameter",
      "kind": "LinkedField",
      "name": "additionalInfo",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "cacde5c4862bf0cca7ebaeb822040c72";

export default node;
